import LoadFailed from './components/load-failed'
import Loading from './components/loading'

const loader = (loading, loadFailed, content) => {
  return loading ? <Loading /> : loadFailed ? <LoadFailed /> : content
}

export default loader
